
















import { Component, Vue } from "vue-property-decorator";
import HfqHead from "./components/head.vue";
import HfqLight from "./components/light.vue";
import HfqQuestion from "./components/question.vue";
import HfqDownload from "./components/download.vue";
import HfqDownloadFun from "./components/downloadFun.vue";
import HfqInfo from "./components/info.vue";

export default Vue.extend({
  data() {
    return {
      downFun: 0,
      companyObj: {},
      companyArr: [
        {
          title: 'haohuan',
          info: [
            '市场有风险，借款需谨慎，具体借款情况以实际审批为准',
            '好分期平台服务由北京微财科技有限公司提供',
            'Copyright@All Rights Reserved'
          ]
        },
        {
          title: 'heika',
          info: [
            '资金来源：贷款资金将由正规金融持牌放款机构提供',
            '贷款有风险，借款需谨慎',
            '请根据个人能力合理贷款，理性消费，避免逾期',
            '贷款额度、放款时间以实际审批结果为准',
            'Copyright ©2019 All Rights Reserved',
            '重庆市黑卡小额贷款有限公司 渝ICP备20000928号-1'
          ]
        },
        {
          title: 'hfq',
          info: [
            '资金来源：贷款资金将由正规金融持牌放款机构提供',
            '贷款有风险，借款需谨慎',
            '请根据个人能力合理贷款，理性消费，避免逾期',
            '贷款额度、利率、放款时间以金融机构实际审批结果/系统处理时间为准',
            '年化利率（单利）：12%-24%',
            'Copyright ©2020 All Rights Reserved',
            '北京微财科技有限公司  京ICP备12052273号-6',
            '公安备案号：11010502042318',
          ]
        },
      ],
      company: "",
      screen: {
        scrollTop: 0,
        clientHeight: 1000,
      },
    };
  },
  components: {
    HfqDownloadFun,
    HfqHead,
    HfqLight,
    HfqQuestion,
    HfqDownload,
    HfqInfo
  },
  methods: {
    download() {},
    handleScroll() {
      this.screen.clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      this.screen.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
    },
    statistics(type: string, content: string) {
      (window as any).sa.track("EventYunyingActivity", {
        ActivityName: "移动主站改版20200708",
        OperationType: type,
        OperationContent: content,
      });
    },
    openHFQ() {
      this.downFun = +new Date();
    },
    openApp() {
      var platform = {
        ios: /iPhone/i.test(navigator.userAgent),
        android: /Android/i.test(navigator.userAgent),
        wechat: /micromessenger/i.test(navigator.userAgent) || /MicroMessenger/i.test(navigator.userAgent),
        qq: /MQQBrowser/i.test(navigator.userAgent) || /QQ/i.test(navigator.userAgent)
      };
      var schemeConfig = {
        ios: "hfqdl://", // 有app：当杀掉app时跳转“haohuan://”scheme会卡在白屏页 故须换成"hfqdl://"
        android: "hfqdl://hfq-home?url=123" // 安卓 没有"url"参数的话会导致异常 只要不是空，不合法的地址也会跳到首页去
      };
      var link;
      platform.ios && (link = schemeConfig.ios);
      platform.android && (link = schemeConfig.android);
      link && (window.location.href = link);
    }
  },
  created() {
    // IOS下禁止用户缩放
    document.addEventListener('gesturestart', function(event) {
        event.preventDefault();
    });
    document.addEventListener('gesturechange', function(event) {
        event.preventDefault();
    });
    document.addEventListener('gestureend', function(event) {
        event.preventDefault();
    });
    var client_h = document.documentElement.clientHeight;
    window.addEventListener("scroll", this.handleScroll, true); // 监听（绑定）滚轮滚动事件
    this.company = (this as any).node_config.stage;
    if(this.company === '51hika') {
      this.companyObj = this.companyArr[1];
    }
    else if(this.company === 'haofenqi'){
      this.companyObj = this.companyArr[2];
    }else {
      this.companyObj = this.companyArr[0];
    }
    this.statistics("浏览", "");

    // this.openApp();
  },
  beforeCreate() {
    const body = document.querySelector('body');
    const html = document.querySelector('html');
    if (body) { body.className = 'bg-color';}
    if (html) { html.className = 'bg-color';}
  },
  beforeDestroy() {
    const body = document.querySelector('body');
    const html = document.querySelector('html');
    if (body) { body.className = '';}
    if (html) { html.className = '';}
  },
});
